import { SendAnalytics, GenerateLabel } from "../main";

const analytics = SendAnalytics('user profile')

/** 👇 user click profile */
const ClickProfile = () => analytics({
  label: GenerateLabel({}),
  action: 'profile - click profile',
  name: 'click_profile',
});

/** 👇 user click profile */
const ClickProfileIcon = () => analytics({
  label: GenerateLabel({}),
  action: 'profile - click profile',
  name: 'click_profile_icon',
});

/** 👇 user view profile */
const ViewProfile = () => analytics({
  label: GenerateLabel({}),
  action: 'profile - view profile',
  name: 'view_profile',
});

/** 👇 user click langganan */
const ClickLangganan = () => analytics({
  label: GenerateLabel({}),
  action: 'profile - click langganan',
  name: 'click_langganan',
});

/** 👇 user view langganan */
const ViewLangganan = () => analytics({
  label: GenerateLabel({}),
  action: 'profile - view langganan',
  name: 'view_langganan',
});

/** 👇 user click bantuan */
const ClickBantuan = () => analytics({
  label: GenerateLabel({}),
  action: 'profile - click bantuan',
  name: 'click_bantuan',
});

/** 👇 user click keamanan */
const ClickKeamanan = () => analytics({
  label: GenerateLabel({}),
  action: 'profile - click keamanan',
  name: 'click_keamanan',
});

/** 👇 user change password */
const SubmitChangePassword = () => analytics({
  label: GenerateLabel({}),
  action: 'profile - change password',
  name: 'submit_change_password',
});

/** 👇 user click ajak teman */
const ClickInviteFriend = () => analytics({
  label: GenerateLabel({}),
  action: 'profile - click ajak teman',
  name: 'click_ajak_teman',
});

/** 👇 user click bagikan */
const ClickBagikan = () => analytics({
  label: GenerateLabel({}),
  action: 'profile - click bagikan',
  name: 'click_bagikan',
});

/** 👇 user click bagikan via socmed */
const ClickShareSocmed = (platform) => analytics({
  label: GenerateLabel({ platform }),
  action: 'profile - click bagikan via socmed',
  name: 'click_share_socmed',
});

/** 👇 user click S&K */
const ClickTermCondition = () => analytics({
  label: GenerateLabel({}),
  action: 'profile - click S&K',
  name: 'click_s&k',
});

/** 👇 user click disclaimer */
const ClickDisclaimer = () => analytics({
  label: GenerateLabel({}),
  action: 'profile - click disclaimer',
  name: 'click_disclaimer',
});

/** 👇 user click tutorial */
const ClickTutorial = () => analytics({
  label: GenerateLabel({}),
  action: 'profile - click tutorial',
  name: 'click_tutorial',
});

/** 👇 user view tutorial */
const ViewTutorial = () => analytics({
  label: GenerateLabel({}),
  action: 'profile - view tutorial',
  name: 'view_tutorial',
});

const Profile = {
  ClickProfile,
  ClickProfileIcon,
  ViewProfile,
  ClickLangganan,
  ViewLangganan,
  ClickBantuan,
  ClickKeamanan,
  SubmitChangePassword,
  ClickInviteFriend,
  ClickBagikan,
  ClickShareSocmed,
  ClickTermCondition,
  ClickDisclaimer,
  ClickTutorial,
  ViewTutorial,
};

export default Profile;
